import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {NgxSpinnerService} from 'ngx-spinner';
import {ActivatedRoute, Router} from '@angular/router';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  form: FormGroup;
  isSubmitted: boolean;
  hash;
  username;
  error;
  showPassword1: boolean = false;
  showPassword2: boolean = false;
  isDialog = false;

  constructor(private formBuilder: FormBuilder, private toaster: ToastrService,
              private spinner: NgxSpinnerService, private route: ActivatedRoute, protected router: Router, private AuthService: AuthService) {
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.hash = params['hash'];
      this.username = params['uname'];
    });

    if (window.location.host.toString().match('dialog')) {
      this.isDialog = true;
    }

    this.form = this.formBuilder.group({
      password: [null, Validators.compose([Validators.required])],
      confirmPassword: [null, Validators.compose([Validators.required])],
    }, {
      validators: this.passwordMatchValidator
    });
  }

  passwordMatchValidator(form: FormGroup) {
    const passwordValue = form.get('password').value;
    const confirmPasswordValue = form.get('confirmPassword').value;

    if (passwordValue !== confirmPasswordValue) {
      form.get('confirmPassword').setErrors({passwordMatchError: true})
    }
    return null;
  }

  reset(entity: any) {
    this.isSubmitted = true;

    if (!this.form.valid) {
      return;
    }

    entity.key = this.hash;
    entity.username = this.username;

    this.AuthService.resetPassword(entity).subscribe((response) => {
      console.log("password update successfully", response); 
      this.spinner.hide();
      this.toaster.success('Password reset successfully', 'Success');
      this.router.navigate(['/login']);
    }, error => {
        this.spinner.hide();
        console.log(error);
        if (error.status === 422) {
          this.error = error.error.message;
        } else {
          this.toaster.error('Oops... Something went wrong', 'Error!');
        }
      });
  }

  togglePassword(fieldNumber: number): void {
    if (fieldNumber === 1) {
      this.showPassword1 = !this.showPassword1;
    } else if (fieldNumber === 2) {
      this.showPassword2 = !this.showPassword2;
    }
  }
}

